module.exports = __webpack_public_path__ + "img/92143.f835f5d0.svg";